








































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { Project } from '@/models/project';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';

import PrineButton from '@/components/prine/PrineButton.vue';
import type { XLesson } from '@/models/xlesson';
import type { XSubProcess } from '@/models/xsubprocess';
import type { XWorksheet } from '@/models/xworksheet';
import { xWorksheetWebservice } from '@/webservices/xworksheet';
import { xSubProcessWebservice } from '@/webservices/xsubprocess';
import type { XProcess } from '@/models/xprocess';
import LessonsList from '@/components/knowledge/lessons/LessonsList.vue';
import UpdateFilter from '@/components/worksheets/UpdateFilter.vue';
import { extractTagsFrom } from '@/helpers/extractTags';
import { LessonsFilter } from '@/helpers/types/LessonsFilter';
import { filterLessonContainer, filterLessons } from '@/helpers/filter/lessons/lessonsFilter';
import { allInLessonContainersSelected } from '@/helpers/filter/lessons/allInLessonContainersSelected';
import { deselectAll, selectAll } from '@/helpers/filter/lessons/selectAll';

@Component({
    name: 'UpdateWorksheetX',
    methods: { extractTagsFrom },
    components: {
        UpdateFilter,
        PrineButton,
        LessonsList,
    },
})
export default class UpdateWorksheetX extends Vue {
    private filters: LessonsFilter = {
        tags: [],
    };
    private checkedLessons = new Array<XLesson>();
    private xSubProcesses = new Array<XSubProcess>();
    private filteredXSubProcesses = new Array<XSubProcess>();
    private selectedXProcess: XProcess = {} as XProcess;

    private option: {
        filterByColumn: boolean;
        filterable: boolean;
    };
    private xWorksheet: XWorksheet = {} as XWorksheet;
    private isLoading: boolean = false;
    private isReady: boolean = false;

    @Getter('project/selectedProject') private selectedProject: Project;

    @Watch('filters', { deep: true })
    private filterLessons() {
        this.filteredXSubProcesses = filterLessonContainer(
            JSON.parse(JSON.stringify(this.xSubProcesses)) as XSubProcess[],
            this.filters
        );
    }

    get allSelected() {
        return allInLessonContainersSelected(this.filteredXSubProcesses, this.checkedLessons);
    }

    private mounted() {
        if (this.$route.query.hasOwnProperty('worksheetId')) {
            this.loadXWorksheetById(Number(this.$route.query.worksheetId));
        } else {
            this.goBack();
        }
    }

    private goBack() {
        // Show the Worksheet View
        this.$router.push({
            name: 'WorksheetView',
            query: {
                id: this.xWorksheet.id.toString(),
                onlyPR: this.$route.query.onlyPR,
                type: this.$route.query.type,
            },
        });
    }

    private loadXWorksheetById(worksheetId: number) {
        xWorksheetWebservice
            .getById(worksheetId)
            .then((response) => {
                this.xWorksheet = response.data;
                this.loadXSubProcessesWithLessons();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private loadXSubProcessesWithLessons() {
        xSubProcessWebservice.load(this.xWorksheet.x_process.id, ApprovalState.APPROVED).then((response) => {
            this.xSubProcesses = response.data;
            this.filterLessons();
            this.checkCurrentAppliedLessons();
        });
    }

    private checkCurrentAppliedLessons() {
        this.filteredXSubProcesses.forEach((xSubProcess) => {
            this.selectAllAppliedLessonsRec(xSubProcess.lessons, this.checkedLessons);
        });
        this.isReady = true;
    }

    private selectAllAppliedLessonsRec(lessons: XLesson[], checkedLessons) {
        lessons.forEach((lesson: XLesson) => {
            if (this.isAppliedLesson(lesson)) {
                checkedLessons.push(lesson);
            }
            if (lesson.sub_lessons) {
                this.selectAllAppliedLessonsRec(lesson.sub_lessons, checkedLessons);
            }
        });
    }

    private isAppliedLesson(lesson: XLesson) {
        return !!this.xWorksheet.x_applied_lessons.find((al) => al.x_lesson_id === lesson.id);
    }

    private selectAllClick() {
        if (this.allSelected) {
            this.checkedLessons = deselectAll(this.filteredXSubProcesses, this.checkedLessons);
        } else {
            this.checkedLessons = selectAll(this.filteredXSubProcesses, this.checkedLessons);
        }
    }

    private updateWorksheet() {
        this.isLoading = true;
        xWorksheetWebservice
            .update(this.xWorksheet, this.checkedLessons)
            .then((response) => {
                this.goBack();
            })
            .catch((error) => {
                console.log(error);
                this.isLoading = false;
            });
    }

    private hr(index) {
        return index > 1;
    }
}
